import { render, staticRenderFns } from "./GlobalPosition.vue?vue&type=template&id=c74095b2&scoped=true&"
import script from "./GlobalPosition.vue?vue&type=script&lang=js&"
export * from "./GlobalPosition.vue?vue&type=script&lang=js&"
import style0 from "./GlobalPosition.vue?vue&type=style&index=0&id=c74095b2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74095b2",
  null
  
)

export default component.exports